import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "../App.css";

const PublicPageLayout = ({ eyebrow, title, intro, children }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="landing-page">
      <nav className="landing-nav">
        <Link to="/" style={{ textDecoration: "none" }}>
          <div className="nav-brand">
            <span className="brand-icon">TD</span>
            <span className="brand-text">Tenant Dispatch</span>
          </div>
        </Link>
        <div className="nav-links">
          <Link to="/" style={{ color: "#64748b", textDecoration: "none", fontWeight: 500 }}>
            Home
          </Link>
          <Link to="/about" style={{ color: "#64748b", textDecoration: "none", fontWeight: 500 }}>
            About
          </Link>
          <Link to="/contact" style={{ color: "#64748b", textDecoration: "none", fontWeight: 500 }}>
            Contact
          </Link>
        </div>
      </nav>

      <section className="public-page-hero">
        <div className="public-page-shell">
          <span className="hero-badge">{eyebrow}</span>
          <h1 className="public-page-title">{title}</h1>
          <p className="public-page-intro">{intro}</p>
        </div>
      </section>

      <section className="public-page-content-wrap">
        <div className="public-page-shell">
          <div className="public-page-card">{children}</div>
        </div>
      </section>

      <footer className="landing-footer">
        <div className="footer-content">
          <div className="footer-brand">
            <span className="brand-icon">TD</span>
            <span className="brand-text">Tenant Dispatch</span>
            <p className="footer-tagline">Automated property maintenance for modern landlords.</p>
          </div>
          <div className="footer-links">
            <div className="footer-column">
              <h4>Company</h4>
              <Link to="/">Home</Link>
              <Link to="/about">About</Link>
              <Link to="/contact">Contact</Link>
            </div>
            <div className="footer-column">
              <h4>Legal</h4>
              <Link to="/privacy">Privacy Policy</Link>
              <Link to="/subprocessors">Subprocessors</Link>
              <Link to="/terms">Terms of Service</Link>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default PublicPageLayout;
